const PRODUCT_NAME_SEARCH_FIELDS = ["name^10", "menuTitle^6", "brand^3"];

const OPENSEARCH_PRODUCTS_STALE_MS = 60_000;

const ORDER_PRODUCT_SEARCH_SIZE = 20;

const OPENSEARCH_PRODUCTS_CATALOG_PAGE_SIZE = 10;

export {
    ORDER_PRODUCT_SEARCH_SIZE,
    OPENSEARCH_PRODUCTS_CATALOG_PAGE_SIZE,
    OPENSEARCH_PRODUCTS_STALE_MS,
    PRODUCT_NAME_SEARCH_FIELDS,
};
